import { AxiosError } from "axios";
import { ReducerBuilder } from "../../utils/redux/reducer-builder";
import { INITIAL_STATE, PlanState, PlanActionTypes } from "./plan-types";
import { Plan } from "../../api/talent/models/plan.model";

const reduxBuilder = new ReducerBuilder<PlanState>(INITIAL_STATE);

reduxBuilder.addMutableReducer(PlanActionTypes.GET_CURRENT_PLAN, (state) => {
  state.currentPlan = INITIAL_STATE.currentPlan;
});

reduxBuilder.addMutableReducer<Plan>(
  PlanActionTypes.GET_CURRENT_PLAN_SUCCESS,
  (state, payload) => {
    state.currentPlan.data = payload;
    state.currentPlan.loading = false;
    state.currentPlan.error = null;
  }
);

reduxBuilder.addMutableReducer<AxiosError<any>>(
  PlanActionTypes.GET_CURRENT_PLAN_ERROR,
  (state, payload) => {
    state.currentPlan.data = null;
    state.currentPlan.loading = true;
    state.currentPlan.error = payload;
  }
);

reduxBuilder.addMutableReducer(PlanActionTypes.SEND_PROSPECT, state => {
  state.prospect.data = INITIAL_STATE.prospect.data;
  state.prospect.loading = true;
  state.prospect.error = null;
});

reduxBuilder.addMutableReducer<any>(
  PlanActionTypes.SEND_PROSPECT_SUCCESS,
  (state, payload) => {
    state.prospect.data = true;
    state.prospect.loading = false;
    state.prospect.error = null;
  }
);

reduxBuilder.addMutableReducer<AxiosError<any>>(
  PlanActionTypes.GET_CURRENT_PLAN_ERROR,
  (state, payload) => {
    state.prospect.data = INITIAL_STATE.prospect.data;
    state.prospect.loading = false;
    state.prospect.error = payload;
  }
);

reduxBuilder.addMutableReducer(PlanActionTypes.SEND_PROSPECT_RESET, state => {
  state.prospect.data = INITIAL_STATE.prospect.data;
  state.prospect.loading = false;
  state.prospect.error = null;
});

export default reduxBuilder.build();
